import { ShieldCheck } from '@drift-labs/icons';
import { UiVaultConfig } from 'src/@types/vaults';
import { useVaultAssetSymbols } from '../../hooks/vaults/useVaultAssetSymbols';
import MarketIcon from '../Utils/MarketIcon';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { useSpotMarkets } from 'src/hooks/spotMarkets/useSpotMarkets';
import { getColorVar } from 'src/utils/theme/colorVars';

export const VaultTagsAlt = (props: { uiVaultConfig: UiVaultConfig }) => {
	const spotMarkets = useSpotMarkets();
	const isVerified = props.uiVaultConfig.vaultManager.isVerified;

	const vaultAssetSymbols = useVaultAssetSymbols(
		props.uiVaultConfig.vaultPubkeyString
	);

	return (
		<div className="flex flex-col items-start justify-center space-y-1">
			<div className="flex flex-wrap items-center gap-x-4xl gap-y-lg sm:gap-x-lg sm:gap-y-sm">
				<span className="flex gap-x-2">
					<span className="typo-b4 text-text-secondary">Manager:</span>
					<Tooltip
						content={
							<>
								These managers have completed basic KYB checks and have provided
								further information regarding vault operation.
							</>
						}
						disabled={!isVerified}
					>
						<span className="typo-t4">
							<span className="flex items-center">
								<span>{props.uiVaultConfig.vaultManager.name}</span>
								{isVerified && (
									<ShieldCheck size={16} color={getColorVar('text-default')} />
								)}
							</span>
						</span>
					</Tooltip>
				</span>

				<span className="flex gap-x-2">
					<span className="typo-b4 text-text-secondary">Deposit:</span>
					<span className="flex space-x-1">
						<MarketIcon
							marketSymbol={
								spotMarkets[props.uiVaultConfig.depositAsset].symbol
							}
							className="h-4 w-4"
						/>
					</span>
				</span>

				<span className="flex gap-x-2">
					<span className="typo-b4 text-text-secondary">Trading:</span>
					<div className="flex items-center xs:gap-1 sm:gap-3">
						{vaultAssetSymbols.map((symbol) => (
							<span key={symbol} className="flex xs:space-x-0.5 sm:space-x-1">
								<MarketIcon
									key={symbol}
									marketSymbol={symbol}
									className="xs:h-4 xs:w-4 sm:h-4 sm:w-4"
								/>
							</span>
						))}
					</div>
				</span>
			</div>
		</div>
	);
};
